// src/components/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="w-full text-center py-4 bg-white border-t mt-10">
      <p className="text-sm text-gray-500">© 2025 Orel Cohen. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
